import React, { Fragment, cloneElement, useRef, useState, useLayoutEffect } from 'react';
import * as ReactDOM from 'react-dom';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = "#style_toast_container__DT-ei * {\n  box-sizing: border-box;\n}\n.style_toast-list__QC6Mo {\n  box-sizing: border-box;\n  position: fixed;\n  z-index: 1000;\n  line-height: 1.5;\n  text-align: center;\n}\n.style_toast-list__QC6Mo.style_bottom-left__OVYBd {\n  bottom: 20px;\n  left: 30px;\n  transform: translateX(0) translateZ(0);\n}\n.style_toast-list__QC6Mo.style_bottom-center__NH15O {\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%) translateZ(0);\n}\n.style_toast-list__QC6Mo.style_bottom-right__HeaCV {\n  right: 30px;\n  bottom: 20px;\n  left: auto;\n  transform: translateX(0) translateZ(0);\n}\n.style_toast-list__QC6Mo.style_top-left__gMJD1 {\n  top: 30px;\n  left: 30px;\n  transform: translateX(0) translateZ(0);\n}\n.style_toast-list__QC6Mo.style_top-center__zZFy4 {\n  top: 30px;\n  left: 50%;\n  transform: translateX(-50%) translateZ(0);\n}\n.style_toast-list__QC6Mo.style_top-right__0Fafq {\n  top: 30px;\n  right: 30px;\n  left: auto;\n  transform: translateX(0) translateZ(0);\n}\n.style_toast-list__QC6Mo.style_center__GLmmM {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) translateZ(0);\n}\n.style_toast-message__-UN8x {\n  opacity: 0;\n  margin-bottom: 10px;\n  transition: height 0.3s, opacity 0.3s, transform 0.3s;\n}\n.style_top-left__gMJD1 .style_toast-message__-UN8x,\n.style_top-center__zZFy4 .style_toast-message__-UN8x,\n.style_top-right__0Fafq .style_toast-message__-UN8x {\n  transform: translateY(-10px);\n}\n.style_toast-content__jaj36 {\n  display: inline-block;\n  overflow: hidden;\n  min-width: 290px;\n  padding: 12px 22px;\n  background: rgba(0, 0, 10, 0.8);\n  box-shadow: 1px 2px 5px 1px rgba(0, 0, 0, 0.2);\n  border-radius: 40px;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto,\n    'Helvetica Neue', Arial, sans-serif;\n  color: #fff;\n  font-size: 16px;\n  text-align: center;\n  line-height: 1.5;\n  vertical-align: top;\n  white-space: pre-line;\n}\n.style_clickable__F3Zx7 {\n  cursor: pointer;\n}\n.style_toast-message__-UN8x.toast-enter-active,\n.style_toast-message__-UN8x.toast-appear-active {\n  opacity: 1;\n  transform: translateY(0px);\n}\n.style_toast-message__-UN8x.toast-exit-active {\n  opacity: 0;\n  transform: translateY(-10px);\n}\n.style_center__GLmmM .style_toast-message__-UN8x.toast-exit-active {\n  transform: translateY(-40px);\n}\n";
var styles = {
  "toast_container": "style_toast_container__DT-ei",
  "toast-list": "style_toast-list__QC6Mo",
  "bottom-left": "style_bottom-left__OVYBd",
  "bottom-center": "style_bottom-center__NH15O",
  "bottom-right": "style_bottom-right__HeaCV",
  "top-left": "style_top-left__gMJD1",
  "top-center": "style_top-center__zZFy4",
  "top-right": "style_top-right__0Fafq",
  "center": "style_center__GLmmM",
  "toast-message": "style_toast-message__-UN8x",
  "toast-content": "style_toast-content__jaj36",
  "clickable": "style_clickable__F3Zx7"
};
styleInject(css_248z);
var createElement = function (id) {
  var element = document.createElement('div');
  element.setAttribute('id', id);
  return element;
};
var addRootElement = function (rootElem) {
  document.body.appendChild(rootElem);
  return rootElem;
};

// Let compiler not to search module usage
var fullClone = __assign({}, ReactDOM);
var version = fullClone.version,
  reactRender = fullClone.render;
fullClone.unmountComponentAtNode;
var createRoot;
try {
  var mainVersion = Number((version || '').split('.')[0]);
  if (mainVersion >= 18 && fullClone.createRoot) {
    createRoot = fullClone.createRoot;
  }
} catch (e) {
  // Do nothing;
}
function toggleWarning(skip) {
  var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && typeof __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === 'object') {
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
  }
}
var MARK = '__rc_react_root__';
function modernRender(node, container) {
  toggleWarning(true);
  var root = container[MARK] || createRoot(container);
  toggleWarning(false);
  root.render(node);
  container[MARK] = root;
}
function legacyRender(node, container) {
  reactRender(node, container);
}
function render(node, container) {
  if (createRoot != null) {
    modernRender(node, container);
    return;
  }
  legacyRender(node, container);
}
var createId = function () {
  return Date.now() + Math.floor(Math.random() * 10000000000000000);
};
var isBrowser = function () {
  return typeof window !== 'undefined';
};
var SET_TIMEOUT_MAX = 2147483647;
var ToastPosition = {
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right',
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  CENTER: 'center'
};
var toastComponentList = [];
var init = function () {
  var toastContainer = isBrowser() && document.getElementById(styles['toast_container']);
  if (isBrowser() && !toastContainer) {
    addRootElement(createElement(styles['toast_container']));
  }
  if (!toastComponentList || !Array.isArray(toastComponentList)) {
    toastComponentList = [];
  }
};
var defaultOptions = {
  time: 3000,
  duration: 3000,
  className: '',
  position: 'bottom-center',
  clickClosable: false,
  render: null,
  maxVisibleToasts: null
};
var isValidPosition = function (position) {
  var positionList = Object.values(ToastPosition);
  if (!positionList.includes(position)) {
    throw new Error("Invalid position value. Expected one of ".concat(Object.values(ToastPosition).join(', '), " but got ").concat(position));
  }
  return true;
};
var toastConfig = function (options) {
  if (options.time) {
    defaultOptions.time = options.time;
  }
  if (options.duration) {
    defaultOptions.duration = options.duration;
  }
  if (options.className) {
    defaultOptions.className = options.className;
  }
  if (options.position && isValidPosition(options.position)) {
    defaultOptions.position = options.position;
  }
  if (options.clickClosable) {
    defaultOptions.clickClosable = options.clickClosable;
  }
  if (options.render) {
    defaultOptions.render = options.render;
  }
  if (options.maxVisibleToasts) {
    defaultOptions.maxVisibleToasts = options.maxVisibleToasts;
  }
};
var renderDOM = function () {
  if (!isBrowser()) return;
  var toastContainer = document.getElementById(styles['toast_container']);
  if (!toastContainer) return;
  var defaultToastList = Object.values(ToastPosition).reduce(function (acc, position) {
    var _a;
    return __assign(__assign({}, acc), (_a = {}, _a[position] = [], _a));
  }, {});
  var toastListByPosition = toastComponentList.reduce(function (acc, toast) {
    acc[toast.position].push(toast);
    return acc;
  }, defaultToastList);
  var toastListComponent = Object.entries(toastListByPosition).map(function (_a) {
    var position = _a[0],
      toastsByPosition = _a[1];
    return /*#__PURE__*/React.createElement("div", {
      key: position,
      className: "".concat(styles['toast-list'], " ").concat(styles[position])
    }, toastsByPosition.map(function (t) {
      return /*#__PURE__*/React.createElement(Fragment, {
        key: t.id
      }, /*#__PURE__*/cloneElement(t.component, {
        isExit: t.isExit
      }));
    }));
  });
  render(/*#__PURE__*/React.createElement(React.Fragment, null, toastListComponent), toastContainer);
};
var clearToasts = function () {
  toastComponentList.forEach(function (toast) {
    return toast.isExit = true;
  });
  renderDOM();
};
var Toast = function (_a) {
  var message = _a.message,
    className = _a.className,
    clickable = _a.clickable,
    position = _a.position,
    isExit = _a.isExit,
    render = _a.render,
    onClick = _a.onClick;
  var messageDOM = useRef(null);
  var _b = useState(false),
    isEnter = _b[0],
    setIsEnter = _b[1];
  useLayoutEffect(function () {
    if (messageDOM.current && messageDOM.current.clientHeight) {
      var height_1 = messageDOM.current.clientHeight;
      messageDOM.current.style.height = '0px';
      setTimeout(function () {
        if (messageDOM.current) messageDOM.current.style.height = "".concat(height_1, "px");
        setIsEnter(true);
      }, 0);
    }
  }, []);
  useLayoutEffect(function () {
    var topOrCenter = position && (position.indexOf('top') > -1 || position === 'center');
    if (isExit && position && topOrCenter) {
      if (messageDOM.current) messageDOM.current.style.height = '0px';
    }
  }, [isExit]);
  var contentClassNames = [styles['toast-content'], clickable ? styles['clickable'] : ''].filter(Boolean).join(' ');
  var clickableProps = {
    onClick: onClick,
    tabIndex: 0,
    role: 'button'
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: messageDOM,
    className: "".concat(styles['toast-message'], " ").concat(isEnter ? 'toast-enter-active' : '', " ").concat(isExit ? 'toast-exit-active' : '', " ").concat(className)
  }, render ? render(message) : /*#__PURE__*/React.createElement("div", _extends({
    className: contentClassNames
  }, clickable && clickableProps), message));
};
function closeToast(id, options) {
  var index = toastComponentList.findIndex(function (t) {
    return t.id === id;
  });
  if (toastComponentList[index]) {
    toastComponentList[index].isExit = true;
  }
  if (options.onCloseStart) {
    options.onCloseStart();
  }
  renderDOM();
  setTimeout(function () {
    toastComponentList = toastComponentList.filter(function (t) {
      return t.id !== id;
    });
    if (options.onClose) {
      options.onClose();
    }
    renderDOM();
  }, 300);
}
function renderToast(message, options) {
  var dummyReturn = {
    close: function () {},
    updateDuration: function () {},
    update: function () {}
  };
  if (!isBrowser()) return dummyReturn;
  var closeTimer;
  var id = createId();
  var _a = options || {},
    _b = _a.time,
    time = _b === void 0 ? undefined : _b,
    duration = _a.duration,
    _c = _a.clickable,
    clickable = _c === void 0 ? false : _c,
    _d = _a.clickClosable,
    clickClosable = _d === void 0 ? defaultOptions.clickClosable : _d,
    _e = _a.className,
    className = _e === void 0 ? defaultOptions.className : _e,
    _f = _a.position,
    position = _f === void 0 ? defaultOptions.position : _f,
    _g = _a.maxVisibleToasts,
    maxVisibleToasts = _g === void 0 ? defaultOptions.maxVisibleToasts : _g,
    _h = _a.render,
    render = _h === void 0 ? defaultOptions.render : _h,
    _j = _a.onClick,
    onClick = _j === void 0 ? undefined : _j,
    _k = _a.onClose,
    onClose = _k === void 0 ? undefined : _k,
    _l = _a.onCloseStart,
    onCloseStart = _l === void 0 ? undefined : _l;
  var durationTime = duration || time || defaultOptions.duration || defaultOptions.time;
  var closeOptions = {
    onClose: onClose,
    onCloseStart: onCloseStart
  };
  if (!isValidPosition(position)) ;
  init();
  var handleClick = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (clickClosable) {
      if (closeTimer) {
        clearTimeout(closeTimer);
      }
      closeToast(id, closeOptions);
    }
    if (onClick) onClick.apply(void 0, args);
  };
  toastComponentList.push({
    id: id,
    message: message,
    position: position,
    component: /*#__PURE__*/React.createElement(Toast, {
      message: message,
      className: className,
      clickable: clickable || clickClosable,
      position: position,
      render: render,
      onClick: handleClick
    })
  });
  var visibleToastOffset = maxVisibleToasts && toastComponentList.length - maxVisibleToasts;
  if (visibleToastOffset) toastComponentList.slice(visibleToastOffset);
  if (maxVisibleToasts) {
    var toastsToRemove = toastComponentList.length - maxVisibleToasts;
    for (var i = 0; i < toastsToRemove; i++) {
      closeToast(toastComponentList[i].id, closeOptions);
    }
  }
  renderDOM();
  var startCloseTimer = function (duration) {
    if (duration === void 0) {
      duration = durationTime;
    }
    if (duration > SET_TIMEOUT_MAX) return;
    if (closeTimer) {
      clearTimeout(closeTimer);
    }
    closeTimer = window.setTimeout(function () {
      closeToast(id, closeOptions);
    }, duration);
  };
  startCloseTimer();
  return {
    close: function () {
      return closeToast(id, closeOptions);
    },
    updateDuration: function (newDuration) {
      if (newDuration === void 0) {
        newDuration = durationTime;
      }
      startCloseTimer(newDuration);
    },
    update: function (newMessage, newDuration) {
      var index = toastComponentList.findIndex(function (t) {
        return t.id === id;
      });
      if (toastComponentList[index]) {
        toastComponentList[index].message = newMessage;
        toastComponentList[index].component = /*#__PURE__*/React.createElement(Toast, {
          message: newMessage,
          className: className,
          clickable: clickable || clickClosable,
          position: position,
          render: render,
          onClick: handleClick
        });
      }
      renderDOM();
      if (newDuration) {
        startCloseTimer(newDuration);
      }
    }
  };
}
function toast(message, durationOrOptions) {
  var options = typeof durationOrOptions === 'number' ? {
    duration: durationOrOptions
  } : durationOrOptions;
  return renderToast(message, options);
}
var createToast = function (options) {
  var toastInstanceId = createId();
  return function (message, durationOrOptions) {
    if (typeof durationOrOptions === 'number') {
      return renderToast(message, {
        toastInstanceId: toastInstanceId,
        duration: durationOrOptions || options.duration
      });
    }
    if (durationOrOptions === undefined || typeof durationOrOptions === 'object') {
      var mergedOptions = __assign(__assign({
        toastInstanceId: toastInstanceId
      }, options), durationOrOptions);
      return renderToast(message, mergedOptions);
    }
    throw new Error('Invalid durationOrOptions type');
  };
};
export { clearToasts, createToast, toast as default, toastConfig };